module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.render) ? _c('div', {
    staticClass: "main-page-box"
  }, [_c('div', {
    staticClass: "back-box",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fas fa-chevron-left fa-fw"
  }), _vm._v("\n    BACK\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "dtls-page"
  }, [_c('div', {
    staticClass: "dtls-hero"
  }, [_c('img', {
    attrs: {
      "src": _vm.view.product_image
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-content"
  }, [_c('div', {
    staticClass: "hero-badge"
  }, [_vm._v("Attraction")]), _vm._v(" "), _c('div', {
    staticClass: "hero-title"
  }, [_vm._v(_vm._s(_vm.view.ProductName))]), _vm._v(" "), _c('div', {
    staticClass: "hero-meta"
  }, [(_vm.view.Location) ? _c('span', [_c('i', {
    staticClass: "fas fa-map-marker-alt fa-fw"
  }), _vm._v("\n            " + _vm._s(_vm.view.Location) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.view.Duration.trim()) ? _c('span', [_c('i', {
    staticClass: "far fa-clock fa-fw"
  }), _vm._v("\n            " + _vm._s(_vm.view.Duration) + "\n          ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "info-bar"
  }, [(_vm.view.Duration.trim()) ? _c('div', {
    staticClass: "info-card"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('label', [_vm._v("Duration")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.view.Duration))])])]) : _vm._e(), _vm._v(" "), (_vm.view.Product_available_date && _vm.view.Product_available_date.length) ? _c('div', {
    staticClass: "info-card"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('label', [_vm._v("Booking Date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formatDate(_vm.view.Product_available_date[0])))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info-card"
  }, [_vm._m(2), _vm._v(" "), _c('div', [_c('label', [_vm._v("Travelers")]), _vm._v(" "), _c('p', [_vm._v("Up to " + _vm._s(_vm.view.MaxTravellerCount))])])]), _vm._v(" "), (_vm.view.VoucherOption_List) ? _c('div', {
    staticClass: "info-card"
  }, [_vm._m(3), _vm._v(" "), _c('div', [_c('label', [_vm._v("Voucher Type")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.view.VoucherOption_List.type))])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "dtls-two-col"
  }, [_c('div', {
    staticClass: "dtls-two-main"
  }, [_c('div', {
    staticClass: "section-box"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "description-text",
    domProps: {
      "innerHTML": _vm._s(_vm.view.Description)
    }
  })]), _vm._v(" "), (_vm.view.Inclusions && _vm.view.Inclusions.length) ? _c('div', {
    staticClass: "section-box"
  }, [_vm._m(5), _vm._v(" "), _vm._l((_vm.view.Inclusions), function(inc) {
    return _c('div', {
      staticClass: "description-text"
    }, [_c('i', {
      staticClass: "fas fa-check fa-fw"
    }), _vm._v("\n          " + _vm._s(inc.description) + "\n        ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.view.Exclusions && _vm.view.Exclusions.length) ? _c('div', {
    staticClass: "section-box"
  }, [_vm._m(6), _vm._v(" "), _vm._l((_vm.view.Exclusions), function(inc) {
    return _c('div', {
      staticClass: "description-text"
    }, [_c('i', {
      staticClass: "fas fa-times fa-fw"
    }), _vm._v("\n          " + _vm._s(inc.description) + "\n        ")])
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dtls-two-side"
  }, [_c('div', {
    staticClass: "price-section"
  }, [_c('div', {
    staticClass: "price-label"
  }, [_vm._v("Price")]), _vm._v(" "), _c('div', {
    staticClass: "price-value"
  }, [_vm._v("\n          " + _vm._s(_vm.currencySymbol[_vm.currency.code]) + "\n          " + _vm._s(_vm.applyCurrency(_vm.view.Price, false)) + " \n          "), _c('span', [_vm._v(_vm._s(_vm.currency.code))])]), _vm._v(" "), _c('div', {
    staticClass: "price-note"
  }, [_vm._v("per person")]), _vm._v(" "), _c('button', {
    staticClass: "km-btn",
    on: {
      "click": _vm.bookNow
    }
  }, [_vm._v("Book Now")])]), _vm._v(" "), (_vm.view.Cancellation_available) ? _c('div', {
    staticClass: "side-card"
  }, [_vm._m(7), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.view.Cancellation_Policy))])]) : _vm._e()])]), _vm._v(" "), _c('traveller-modal', {
    ref: "trvModal",
    attrs: {
      "trData": _vm.view
    }
  })], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-icon"
  }, [_c('i', {
    staticClass: "far fa-clock fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-icon"
  }, [_c('i', {
    staticClass: "far fa-calendar fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-icon"
  }, [_c('i', {
    staticClass: "fas fa-users fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-icon"
  }, [_c('i', {
    staticClass: "far fa-file-alt fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sb-header"
  }, [_c('div', {
    staticClass: "sb-icon"
  }, [_c('i', {
    staticClass: "fas fa-info-circle fa-fw"
  })]), _vm._v(" "), _c('label', [_vm._v("About This Experience")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sb-header"
  }, [_c('div', {
    staticClass: "sb-icon"
  }, [_c('i', {
    staticClass: "fas fa-info-circle fa-fw"
  })]), _vm._v(" "), _c('label', [_vm._v("What's Included")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sb-header"
  }, [_c('div', {
    staticClass: "sb-icon"
  }, [_c('i', {
    staticClass: "fas fa-info-circle fa-fw"
  })]), _vm._v(" "), _c('label', [_vm._v("What's NOT Included")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "side-label"
  }, [_c('i', {
    staticClass: "far fa-check-circle fa-fw"
  }), _vm._v("\n          Cancellation Policy\n        ")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1f09ea1d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f09ea1d","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/D2DSightSeeing/details/index.vue
// module id = 2050
// module chunks = 0